<template>
	<div class="ms-photoalbum-slideshow">
		<Loading v-if="loading" opacity="0.5"/>
		<v-toolbar flat class="header" color="primary" height="60px" style="z-index: 103;">
			<v-toolbar-items>
				<v-btn flat dark @click="onClickBack"><v-icon>chevron_left</v-icon></v-btn>
			</v-toolbar-items>
			<v-spacer />
			<v-toolbar-items>
				<v-layout class="align-center">
					<v-flex>
						<nl2br tag="h4" class-name="album-title" :text="headerTitle" />
					</v-flex>
				</v-layout>
			</v-toolbar-items>
			<v-spacer />
			<v-toolbar-items>
				<v-btn flat dark disabled class="header-menu-button"><v-icon>menu</v-icon></v-btn>
			</v-toolbar-items>
		</v-toolbar>
		<div style="position:relative; padding-top: 60px; padding-bottom:56px; height:100%;">
			<v-layout class="align-center" style="height:100%">
				<v-spacer />
				<v-flex>
					<v-lazy-image
						:key="selectedImageSrc"
						:src="selectedImageSrc"
						style="width:100%;"
					/>
				</v-flex>
				<v-spacer />
			</v-layout>
			<div v-if="album && album.items.length > 1"
				class="btn-navigation btn-navigation-prev"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
				@click="onClickBtnNavigationPrev"
			>
				<v-layout class="align-center" style="height: 100%">
					<v-icon>arrow_left</v-icon>
				</v-layout>
			</div>
			<div v-if="album && album.items.length > 1"
				class="btn-navigation btn-navigation-next"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
				@click="onClickBtnNavigationNext"
			>
				<v-layout class="align-center" style="height: 100%">
					<v-icon>arrow_right</v-icon>
				</v-layout>
			</div>
		</div>
		<v-layout class="footer-menu white" outline>
			<v-flex xs6>
				<v-btn v-if="canDelete" flat block dark color="#ff5252" @click="onClickDelete">削除</v-btn>
			</v-flex>
			<v-flex xs6>
				<v-btn v-if="canDownload" flat block dark color="primary" @click="onClickDownload">ダウンロード</v-btn>
			</v-flex>
		</v-layout>
		<DialogConfirmDeletePhotoAlbumItem
			:display="dialog_del.display"
			@click-cancel="onClickCancelDelete"
			@click-confirm="onClickConfirmDelete"
		/>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import DialogConfirmDeletePhotoAlbumItem from './DialogConfirmDeletePhotoAlbumItem';
import VLazyImage from 'v-lazy-image';
import APIClient from '../../classes/APIClient';
import Loading from '../Loading';
import Util from '../../classes/Util';
import ConoHa from '../../classes/ConoHa';

const strftime = require('strftime');

export default {
	data() {
		return {
			loading: false,
			api: null,
			conoha: null,
			album: null,
			dialog_del: { display: false },
		};
	},
	components: {
		DialogConfirmDeletePhotoAlbumItem,
		Loading,
		VLazyImage,
	},
	methods: {
		initData: function(route) {
			this.loading = true;
			return this.fetch(route.params.contractor_id, route.params.photoalbum_id)
				.then(() => {
					this.loading = false;
				});
		},
		gotoItem: function(id) {
			let uri = '/' + [
				this.$route.params.contractor_id, 'member', this.$route.params.id,
				'photoalbum', this.$route.params.photoalbum_id, 'slideshow',
			].join('/') + '#' + id;
			this.$router.push(uri);
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onClickBack: function() {
			let uri = '/' + [
				this.$route.params.contractor_id, 'member', this.$route.params.id,
				'photoalbum', this.$route.params.photoalbum_id,
			].join('/');
			this.$router.push(uri);
		},
		onClickDelete: function() {
			this.dialog_del.display = true;
		},
		onClickCancelDelete: function() {
			this.dialog_del.display = false;
		},
		onClickConfirmDelete: function() {
			let item = this.findItem();
			if (!item)
				return;
			this.loading = true;

			let contractor_id = this.$route.params.contractor_id;
			let photoalbum_id = this.$route.params.photoalbum_id;

			let next_index = this.indexOfItem() - 1;
			if (next_index < 0)
				next_index = 1;
			let next_item = this.album.items.length > 1 ? this.album.items[next_index] : null;
			this.deleteItems(contractor_id, photoalbum_id, [item])
				.then(async () => {
					await this.deleteFromConoHa([item]);
					if (next_item)
						this.gotoItem(next_item.id);
					else
						this.onClickBack();
				})
				.catch(() => {
					this.error('写真の削除に失敗しました');
				})
				.then(() => {
					this.loading = false;
					this.dialog_del.display = false;
				});
		},
		onClickDownload: function() {
			let item = this.findItem();
			if (item) {
				let a = document.createElement('a');
				a.setAttribute('href', item.photo_uri);
				a.setAttribute('download', '');
				document.body.appendChild(a);
				try {
					a.click();
				} finally {
					document.body.removeChild(a);
				}
			}
		},
		onClickBtnNavigation: function(e) {
			var btn = e.target.getElementsByClassName('v-btn')[0];
			if (btn)
				btn.click();
		},
		onMouseEnter: function(e) {
			e.target.classList.add('hover');
		},
		onMouseLeave: function(e) {
			e.target.classList.remove('hover');
		},
		onClickBtnNavigationPrev: function(e) {
			e.target.blur();
			let item = this.prevItem();
			if (item) 
				this.gotoItem(item.id);
		},
		onClickBtnNavigationNext: function(e) {
			e.target.blur();
			let item = this.nextItem();
			if (item) 
				this.gotoItem(item.id);
		},
		indexOfItem: function() {
			if (!this.album)
				return -1;

			let id = this.$route.hash.replace('#', '');
			return this.album.items.findIndex(item => {
				return item.id == id;
			});
		},
		prevItem: function() {
			let index = this.indexOfItem() - 1;
			if (index < 0)
				index = this.album.items.length - 1;
			return this.album.items[index];
		},
		nextItem: function() {
			let index = this.indexOfItem() + 1;
			if (this.album.items.length <= index)
				index = 0;
			return this.album.items[index];
		},
		findItem: function() {
			let index = this.indexOfItem();
			if (index < 0)
				return undefined;

			return this.album.items[index];
		},
		deleteFromConoHa: function(items) {
			return Util.chunkSplitPromiseAll(items, async (item) => {
				/* サムネイルは残す */
				// await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		fetch: async function(contractor_id, photoalbum_id) {
			this.album = null;
			return this.api.getPhotoAlbum(photoalbum_id)
				.then(async (res) => {
					let utc = Util.getUTCFromYMDHMS(res.data.last_modified_at);
					this.album = res.data;
					this.album.last_modified = strftime('%Y年%m月%d日', new Date(utc));

					try {
						this.api.updateBrowseHistory(photoalbum_id);
					} catch {
						// エラー握りつぶす！
					}
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.error('アルバムが見つかりません');
						break;
					default:
						this.error('アルバムの取得に失敗しました');
					}
				});
		},
		deleteItems: async function(contractor_id, photoalbum_id, items) {
			return this.api.deletePhotoAlbumItems(photoalbum_id, items)
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
	},
	computed: {
		canDelete: function() {
			if (this.indexOfItem() < 0)
				return false;
			return this.$store.getters.isAdmin;
		},
		canDownload: function() {
			return this.indexOfItem() >= 0;
		},
		headerTitle() {
			if (this.album == null)
				return '';

			let index = this.indexOfItem();
			if (index < 0)
				return '';
			let item = this.album.items[index];
			return this.album.title.substring(0, 15) +
				'(' + (index + 1) + '/' + this.album.items.length + ')' +
				"\n" +
				item.insert_member_name;
		},
		selectedImageSrc: function() {
			if (!this.album)
				return '';

			let item = this.findItem();
			if (!item)
				return '';

			return item.photo_uri;
		},
	},
	watch: {
		selectedImageSrc: function(value) {
			if (!this.album)
				return;

			if (!value || value.length == 0)
				this.error('写真がありません');
		},
	},
	mounted() {
		this.api = new APIClient(this.$store);
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData(this.$route);
	},
	beforeRouteUpdate(to, from, next) {
		this.initData(to)
			.then(() => {
				next();
			});
	},
};
</script>
<style>
	.ms-photoalbum-slideshow {
		height: 100%;
		background-color: black;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	.ms-photoalbum-slideshow .header {
		position: fixed;
		top: 0;
		left: 0;
		text-align: center;
	}

	.ms-photoalbum-slideshow .header-menu-button[disabled="disabled"] {
		opacity: 0;
	}

	.ms-photoalbum-slideshow .album-title {
		color: white;
	}

	.ms-photoalbum-slideshow .footer-menu {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		background-color: white;
		border-top: 1px solid;
	}

	.ms-photoalbum-slideshow .btn-navigation {
		position: absolute;
		top: 0;
		height: 100%;
		width: 6em;
		cursor: pointer;
	}

	.ms-photoalbum-slideshow .btn-navigation.hover {
		background-color: white;
		opacity: .3;
	}

	.ms-photoalbum-slideshow .btn-navigation .v-btn {
		padding: 0;
		margin: 0;
		height: 88px;
	}

	.ms-photoalbum-slideshow .btn-navigation .v-icon {
		font-size: 88px;
		color: white;
		display: none;
	}

	.ms-photoalbum-slideshow .btn-navigation.hover .v-icon {
		color: black;
		display: inline;
	}

	.ms-photoalbum-slideshow .btn-navigation-perv {
		left: 0;
	}

	.ms-photoalbum-slideshow .btn-navigation-next {
		right: 0;
	}
</style>
